import React from "react";

export default function RightArrow({ color = "currentColor" }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 36 36"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1933 16.9884L10.0808 2.84157C10.0335 2.80431 9.9766 2.78115 9.9167 2.77476C9.85681 2.76837 9.79632 2.779 9.7422 2.80543C9.68807 2.83186 9.6425 2.87303 9.61071 2.92419C9.57893 2.97536 9.56222 3.03446 9.5625 3.09469V6.2005C9.5625 6.39737 9.65491 6.58621 9.80759 6.70674L24.2719 18.0009L9.80759 29.2951C9.6509 29.4157 9.5625 29.6045 9.5625 29.8014V32.9072C9.5625 33.1764 9.87188 33.325 10.0808 33.1603L28.1933 19.0134C28.3473 18.8934 28.4718 18.7398 28.5574 18.5643C28.6431 18.3889 28.6876 18.1962 28.6876 18.0009C28.6876 17.8057 28.6431 17.613 28.5574 17.4376C28.4718 17.2621 28.3473 17.1085 28.1933 16.9884Z"
        fill={!!color ? color : "black"}
        fillOpacity="0.85"
      />
    </svg>
  );
}
